import { WebSocketInterceptor } from "@mswjs/interceptors/WebSocket";
const webSocketInterceptor = new WebSocketInterceptor();
export {
  webSocketInterceptor
};
